module.exports = __webpack_public_path__ + "static/media/sub_meal01.70f97ded.png";